import factory from './icon';
import Svg from './glyphs/plus.svg';

export default factory(Svg);
